module.exports = __webpack_public_path__ + "static/media/settings.cbfd37ee.svg";